var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-yellow1 btn-yellow",on:{"click":_vm.showPage2}},[_vm._v("Install To See More")])}
var staticRenderFns = []

export { render, staticRenderFns }